import { decryptData } from '../utils/crypto';

export const  getUserInfo = ()=>{
    const userInfoFromStorage = decryptData(localStorage.getItem('userInfo'))
? JSON.parse(decryptData(localStorage.getItem('userInfo')))
: null;
if(userInfoFromStorage){
    return userInfoFromStorage.authorizationToken
}
return null 
}